import React from "react";
import omit from "@/utils/omit";
import { IconProps } from "../interface";

const IconRefresh = React.forwardRef<SVGSVGElement, IconProps>((props, ref) => (
  <svg
    width="42"
    height="42"
    viewBox="0 0 42 42"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    className="yfm-icon yfm-icon-refresh"
    {...omit(props, ["className"])}
  >
    <path
      d="M0 21C0 9.40202 9.40202 0 21 0C32.598 0 42 9.40202 42 21C42 32.598 32.598 42 21 42C9.40202 42 0 32.598 0 21Z"
      fill="#25F4EE"
    />
    <path
      d="M30.0743 21.154C30.2721 21.1737 30.454 21.2712 30.58 21.4249C30.706 21.5787 30.7658 21.7762 30.7463 21.974C30.2563 26.904 26.0883 30.75 21.0223 30.75C18.2983 30.75 15.6583 29.817 13.7843 28.07L12.0003 29.85C11.8014 29.85 11.6106 29.771 11.4699 29.6303C11.3293 29.4897 11.2503 29.2989 11.2503 29.1V25.14C11.2503 24.426 11.8303 23.85 12.5413 23.85H16.5113C16.7102 23.85 16.9009 23.929 17.0416 24.0697C17.1823 24.2103 17.2613 24.4011 17.2613 24.6L14.8483 27.007C16.4063 28.44 18.6283 29.25 21.0223 29.25C25.3123 29.25 28.8393 25.992 29.2543 21.826C29.274 21.6282 29.3714 21.4463 29.5252 21.3203C29.6789 21.1943 29.8764 21.1345 30.0743 21.154ZM11.2543 20.026C11.7443 15.096 15.9123 11.25 20.9783 11.25C23.7023 11.25 26.3423 12.183 28.2163 13.93L30.0003 12.15C30.1992 12.15 30.3899 12.229 30.5306 12.3697C30.6713 12.5103 30.7503 12.7011 30.7503 12.9V16.86C30.7503 17.574 30.1703 18.15 29.4593 18.15H25.4893C25.2904 18.15 25.0996 18.071 24.9589 17.9303C24.8183 17.7897 24.7393 17.5989 24.7393 17.4L27.1523 14.992C25.5943 13.56 23.3723 12.75 20.9783 12.75C16.6883 12.75 13.1613 16.008 12.7463 20.174C12.7394 20.2742 12.7124 20.3719 12.6671 20.4614C12.6217 20.551 12.5588 20.6305 12.4821 20.6953C12.4054 20.7601 12.3165 20.8088 12.2206 20.8386C12.1248 20.8684 12.0239 20.8787 11.924 20.8688C11.8241 20.8589 11.7272 20.829 11.6391 20.7809C11.5509 20.7329 11.4733 20.6676 11.4109 20.589C11.3484 20.5105 11.3024 20.4201 11.2755 20.3234C11.2486 20.2267 11.2414 20.1256 11.2543 20.026Z"
      fill="#17215C"
    />
  </svg>
));

IconRefresh.displayName = "IconRefresh";

export default IconRefresh;
